import React, { useState } from "react";
import { navigationLinks } from "../mock";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  return (
    <header className="fixed top-0 w-full bg-black/80 backdrop-blur z-50">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        
        {/* Logo */}
        <img
          src="https://customer-assets.emergentagent.com/job_gym-launch-site/artifacts/7c6h42gu_TFJ_Print_Original.png"
          alt="The Fitness Junction"
          className="h-10"
        />

        {/* Desktop Nav */}
        <nav className="hidden md:flex gap-8">
          {navigationLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.href)}
              className="text-white hover:text-brand-primary font-semibold transition"
            >
              {link.name}
            </button>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-gray-900 px-6 pb-6">
          {navigationLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.href)}
              className="block w-full text-left py-3 text-white hover:text-brand-primary font-semibold"
            >
              {link.name}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
